import axios from "axios";
import { apiEndpoints } from "./endpoints";

export const httpClient = axios.create({
  baseURL: apiEndpoints.backendAwsUrl,
});
